import {
  Button,
  Flex,
  MessageCircleHeartIcon,
  Heading,
} from '@buffer-mono/popcorn'

import type { Campaign, SelectedTag } from '~publish/legacy/campaign/types'
import { FeedbackWidget } from '~publish/components/FeedbackWidget'
import { TagsSelector } from '~publish/legacy/shared-components'
import ComposerActionCreators from '../../action-creators/ComposerActionCreators'
import { Section } from './styles'
import { BackToOmniButton } from './BackToOmniButton'
import { useAccount } from '~publish/contexts/AccountContext'

type HeaderProps = {
  editMode: boolean
  draftMode: boolean
  duplicateMode: boolean
  showCampaignSelector: boolean

  campaigns?: Campaign[] | []

  campaignId?: string | null
  preSelectedTags?: SelectedTag[]
}

export const Header = ({
  editMode = false,
  draftMode = false,
  duplicateMode = false,
  preSelectedTags = [],
}: HeaderProps): JSX.Element => {
  const { account } = useAccount()
  const isBetaEnabled = account?.currentOrganization?.isBetaEnabled

  const onSelectTags = (selectedTags: SelectedTag[]): void => {
    ComposerActionCreators.updateDraftsTags(selectedTags)
  }
  const action = duplicateMode ? 'Duplicate' : editMode ? 'Edit' : 'Create'
  const type = draftMode ? 'Draft' : 'Post'

  return (
    <Section>
      <Flex gap="xs" align="center">
        <BackToOmniButton />
        <Heading as="h2">
          {action} {type}
        </Heading>
      </Flex>
      <Flex gap="xs">
        {isBetaEnabled && (
          <FeedbackWidget
            id="composer-header"
            source="publish"
            description="Thanks for using Buffer! Let us know what you think about our editing & scheduling tools."
          >
            <Button variant="tertiary">
              <MessageCircleHeartIcon />
              Share Feedback
            </Button>
          </FeedbackWidget>
        )}
        <TagsSelector
          onSelectTags={onSelectTags}
          preSelectedTags={preSelectedTags}
          source="postsComposer"
        />
      </Flex>
    </Section>
  )
}
